import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { LineHeightSelect as LocalLineHeightSelect } from '../../components/LineHeightSelect'

export const LineHeightSelect = connect(
  LocalLineHeightSelect,
  mapReadPretty(LocalLineHeightSelect, { disabled: true })
)
